exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods_tag[data-v-7c0b43fa]{border:1px solid #eeeeee;margin-bottom:10px}.goods_tag .left_info[data-v-7c0b43fa]{padding:10px}.goods_tag .left_info>div p[data-v-7c0b43fa]{color:#999999;margin-top:10px}.goods_tag .left_info>div p[data-v-7c0b43fa]:first-child{color:#666666;margin-top:0}.goods_tag .el-image[data-v-7c0b43fa]{width:90px;height:90px;margin-right:10px}.goods_tag .tool[data-v-7c0b43fa]{width:30px;border-left:1px solid #eeeeee}.goods_tag .tool span+span[data-v-7c0b43fa]{margin-top:20px}\n", ""]);

// exports
